import { Component, Input, OnInit } from '@angular/core';
import { ColumnFieldTitle, OfbizList, RemoteFormData } from '@urbannex/ofbiz-forms';
import { UbsBlogService } from '../../../services/ubs-blog.service';
import { ActivatedRoute, Router } from '@angular/router';
import { FORMS } from '../../forms';

@Component({
  selector: 'ubs-blog-roles',
  templateUrl: './ubs-blog-roles.component.html',
  styleUrls: ['./ubs-blog-roles.component.scss']
})
export class UbsBlogRolesComponent implements OnInit{
  @Input() blogContentId:string;

  listForm = new OfbizList({
    fieldFormName:"BlogRoles",
    fieldFormLocation:"local",
    fieldFormFields:this.blogService.getFields("BlogRoles",FORMS),
    columnFields:this.blogService.getFields("BlogRoles",FORMS),
    columnFieldTitles:this.blogService.getColumnFieldTitles("BlogRoles",FORMS),
    listType:"grid",
    listFormName:"BlogRoles",
    listFormLocation:"component://kwikstore/widget/WebSiteContentForms.xml",
    emptyListMessage:"No articles found for this blog. Please create a new blog article",
    endPoint:"",
    entityName:"",
    idFieldName:"contentId",
    remoteFormData:{
      formData:{
        formName:"BlogRoles",
        formLocation:"component://kwikstore/widget/WebSiteContentForms.xml",
        listType:"grid",

      },
      parameters:{"blogContentId":""}
    },

  })

  remoteFormData:RemoteFormData;
  listOptions:any = {};
  fieldOptions:any = {};
  columnFields:any = {};
  columnFieldTitles:ColumnFieldTitle[];
  state$:null;
  result:null;


  constructor(private blogService:UbsBlogService,
    private route:ActivatedRoute,
    private router:Router){

  }

  ngOnInit(): void {
    this.route.paramMap.subscribe((params) => {
      if(params.get("blogContentId")){
        this.blogContentId = params.get("blogContentId");
        this.listForm.remoteFormData.parameters["blogContentId"] = this.blogContentId;
        this.remoteFormData = this.listForm.remoteFormData;
      }
    })
    this.listOptions.formName = this.listForm.listFormName;
    this.listOptions.entityName = this.listForm.entityName;
    this.listOptions.formLocation = this.listForm.listFormLocation;
    this.listOptions.viewIndex = this.listForm.viewIndex || 0;
    this.listOptions.endPoint = this.listForm.endPoint;
    this.listOptions.idFieldName = this.listForm.idFieldName;

    this.columnFieldsFromListForm(this.listForm);
  }

  rowSelected(e){
    console.log(e);
    let data = e["data"];
    if(data["parameterMaps"]){
      let parameterMap = data["parameterMaps"][0];
      console.log(parameterMap["parameterMap"]);
      let blogContentId = parameterMap["parameterMap"].blogContentId;
      let articleContentId = parameterMap["parameterMap"].articleContentId;
      //:blogContentId/article/:articleContentId'
      let url = "/admin/blog/"+blogContentId+"/article/"+articleContentId
      this.router.navigateByUrl(url)
      //this.router.navigate(["blogContentId",blogContentId,"articleContentId",articleContentId], {relativeTo: this.route})
    }
  }

  columnFieldsFromListForm(listForm:OfbizList){
    this.columnFields = listForm.columnFields;
    this.fieldOptions = listForm.fieldFormFields;
    if(listForm.idFieldName){
      this.listOptions["idFieldName"] = listForm.idFieldName;
    console.log({"ListOptions":this.listOptions});
    if(listForm.target){
      this.listOptions.target = listForm.target;
    }
    }
  }

  showOverview(e){
    console.log("Overview selected in list-form-container");
    //this.componentStore.updateSelectedValue(e);
    //this.componentStore.updateAction(ActionState.VIEW);
  }

  showEditDialog(e){
    console.log(e)
    /* let activeLevel:number = 1;
    e["componentConfig"] = this.componentConfig;
    this.componentStore.activeLevel$.subscribe((data:number) => {
      e["activeLevel"] = data;
      this.dialogService.open(DialogContainerComponent, {
        context: e
      }).onClose.subscribe(data => {
        if(data === "success"){
          this.ofbizList.refreshList()
        }
      });
    }) */
    
  }
}
